// src/messaging/useUnreadCount.js
// 未読の合計（あとで画面の枠にバッジを出すため）【2026-10-16】
//   = 会話の未読（conversations[].unread の合計）+ 承認待ちの申請（学生）+ 未読のお知らせ（学生: 授業・大学）
//   リアルタイムの合図・60秒ごと・window の 'messages-changed' イベント（メッセージ／お知らせの画面で既読にしたとき）で取り直す。
//
//   const total = useUnreadCount(user);                 // 数字だけ
//   const { total, messages, requests, notices } = useUnreadBreakdown(user);
import { useCallback, useEffect, useRef, useState } from 'react';
import { msgApi, loadFeatures } from './api';
import { useRealtime } from './util';

const ZERO = { total: 0, messages: 0, requests: 0, notices: 0 };

export function useUnreadBreakdown(user) {
  const [counts, setCounts] = useState(ZERO);
  const role = user && user.role;
  const dev = !!(user && user.isDeveloper);
  const loggedIn = !!(user && user.id);

  const refresh = useCallback(async () => {
    if (!loggedIn) { setCounts(ZERO); return; }
    const f = ((await loadFeatures()) || {}).features || {};
    const isStudent = role === 'student';
    const on = (k) => dev || !!f[k];
    const [c, rq, an, bl] = await Promise.all([
      msgApi.get('/conversations?status=active'),
      isStudent ? msgApi.get('/requests') : null,
      isStudent && on('announcements') ? msgApi.get('/announcements') : null,
      isStudent && on('bulletins') ? msgApi.get('/bulletins/inbox') : null,
    ]);
    const messages = c && c.success ? c.conversations.reduce((s, x) => s + (Number(x.unread) || 0), 0) : 0;
    const requests = rq && rq.success ? rq.requests.length : 0;
    const notices = (an && an.success ? Number(an.unread) || 0 : 0) + (bl && bl.success ? Number(bl.unread) || 0 : 0);
    setCounts({ total: messages + requests + notices, messages, requests, notices });
  }, [loggedIn, role, dev]);

  // 合図が続けて来たときは1回にまとめる
  const timer = useRef(null);
  const soon = useCallback(() => {
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => { timer.current = null; refresh(); }, 800);
  }, [refresh]);

  useEffect(() => {
    refresh();
    const t = setInterval(() => { if (document.visibilityState === 'visible') refresh(); }, 60000);
    window.addEventListener('messages-changed', soon);
    return () => {
      clearInterval(t);
      window.removeEventListener('messages-changed', soon);
      if (timer.current) { clearTimeout(timer.current); timer.current = null; }
    };
  }, [refresh, soon]);

  useRealtime((ev) => {
    if (['message', 'read', 'conversation', 'bulletin', 'announcement'].includes(ev.type)) soon();
  });

  return { ...counts, refresh };
}

export function useUnreadCount(user) {
  return useUnreadBreakdown(user).total;
}

export default useUnreadCount;
